export const phoneRegex = /^(\(0\))?\d{6,19}$/;
export const nameRegex = /^(?!.*[.]{2})(?!.*--)(?![.\- ])(?!.*[.\- ]$)[A-Za-z0-9ÄÖÜäöüßé.\- ]{1,100}$/;
export const textNumberRegex = /^[a-z A-Z 0-9 äöüÄÖÜßé.,-]*$/;
export const numberRegex = /^[0-9]*$/;
export const floatNumberRegex = /^\d+(\.\d+)?$/;
export const fiveFloatValueNumberRegex = /^\d+(\.\d{1,5})?$/;
export const singleNumberDigitRegex = /\d/;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
export const numberRegexAcceptDotAndComma = /^[0-9][0-9 \.,]*$/;
export const taxIdentificationNumberRegex = /^[0-9]{11}$/;
